<template>
  <esp-el-dialog title="人员选择"
                 width="80%"
                 height="85%"
                 ref="psnDialogM"
                 class="esp_psn_dialog_m"
                 @doAction="doAction">
    <div class="esp_psn_content">
      <div class="esp_psn_head">
        <esp-corp v-model="tabParam.searchParam.pk_corp"
                  @change="corpChange"
                  :disabled="isMustCorp"
                  placeholder="选择公司">
        </esp-corp>
        <el-select v-model="tabParam.searchParam.isSeal"
                   @change="tableReLocad()"
                   placeholder="请选择状态"
                   clearable>
          <el-option key="N" label="启用" value="N"></el-option>
          <el-option key="Y" label="停用" value="Y"></el-option>
        </el-select>
        <el-input v-model="tabParam.searchParam.key"
                  @change="tableReLocad()"
                  placeholder="关键词..." suffix-icon="el-icon-search"
                  clearable>
          <el-button slot="append" icon="el-icon-search" @click="tableReLocad()"></el-button>
        </el-input>
      </div>
      <div class="esp_psn_body">
        <el-table :data="tableData.data"
                  @sort-change="sortChange"
                  @selection-change="selectDataM = $event"
                  v-loading="tabParam.showLoading"
                  highlight-current-row stripe
                  height="100%"
                  row-key="pk"
                  ref="table"
                  size="mini"
                  border
                  stripe>
          <el-table-column type="selection" width="30px" :reserve-selection="true"></el-table-column>
          <el-table-column label="人员编码" prop="code"></el-table-column>
          <el-table-column label="人员姓名" prop="name"></el-table-column>
          <el-table-column label="部门" prop="deptdoc.name"></el-table-column>
          <el-table-column label="性别" width="70px">
            <template slot-scope="scope">{{ scope.row.sex == 1 ? "男" : "女" }}</template>
          </el-table-column>
          <el-table-column label="状态" width="70px">
            <template slot-scope="scope">
              <div v-if="scope.row.isSeal == 'Y'">停用</div>
              <div v-else style="color: #27B671">启用</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="esp_psn_footer">
        <el-pagination @size-change="tableSizeChange"
                       @current-change="tableReLocad"
                       :current-page="tabParam.pageNum"
                       :page-sizes="tabParam.pageSizeGroup"
                       :page-size="tabParam.pageSize"
                       :total="tableData.totalRow"
                       layout="total, prev, pager, next, sizes, jumper"
                       background>
        </el-pagination>
      </div>
    </div>
  </esp-el-dialog>
</template>

<script>
import * as psndoc from "@/api/base/psndoc";

export default {
  name: "EspPsndocM",
  data() {
    return {
      selectDataM: [],              // 选择的数据

      tableData: {
        totalRow: 0,                // 总行数
        data: []                    // 表格中的数据
      },
      tabParam: {
        showLoading: false,                           // 是否显示加载框
        pageSizeGroup: this.espConstant.esp_page_size_group,    // 每页数量
        pageNum: 1,                                   // 当前页码
        pageSize: this.espConstant.esp_page_size,     // 每页数量
        sortCol: "",                                  // 排序字段下标
        sortType: 1,                                  // 排序方式
        searchParam: {
          pk_corp: "",
          isSeal: "N",
          key: ""
        }
      }
    }
  },
  props: {
    pk_corp: {
      type: String,
      default: ""
    },
    isMustCorp: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init: function () {
      this.selectDataM = [];
      if (this.$refs.table) {
        this.$refs.table.clearSelection();
      }
      this.tableReLocad();
      this.$refs.psnDialogM.opened();
    },

    /**
     * 确定按钮
     */
    doAction: function (callback) {
      this.$emit("afterSelect", this.selectDataM);
      callback(true);
    },

    /**
     * 公司改变
     */
    corpChange: function () {
      this.tableReLocad();
    },

    /**
     * 加载表格数据
     */
    tableReLocad: function (val) {
      if (!this.tabParam.searchParam.pk_corp && this.isMustCorp) {
        this.tableData = [];
        return;
      }

      if (val != undefined) {
        this.tabParam.pageNum = val;
      } else {
        this.tabParam.pageNum = 1;
      }

      this.tabParam.showLoading = true;
      psndoc.list(this.tabParam).then(resp => {
        if (resp.data) {
          this.tableData = resp;
        } else {
          this.tableData = {
            totalRow: 0,
            data: []
          }
        }
        this.tabParam.showLoading = false;
      }).catch(error => {
        this.tabParam.showLoading = false;
      });
    },

    /**
     * 排序事件
     */
    sortChange: function (col) {
      if (col.prop) {
        this.tabParam.sortCol = col.prop;
        if (col.order == "descending") {
          this.tabParam.sortType = 2;
        } else {
          this.tabParam.sortType = 1;
        }
        this.tableReLocad();
      }
    },

    /**
     * 每页行数变化事件
     */
    tableSizeChange: function (val) {
      this.tabParam.pageSize = val;
      this.tableReLocad();
    }
  },
  watch: {
    pk_corp: {
      handler(newVal, oldVal) {
        if (newVal == null && this.isMustCorp == true) {
          this.tabParam.searchParam.pk_corp = "No Corp Data"
        } else {
          this.tabParam.searchParam.pk_corp = newVal
        }
        this.corpChange();
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less">
.esp_psn_dialog_m {
  .esp_psn_content {
    height: 100%;
    display: flex;
    flex-direction: column;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .esp_psn_head {
      .el-select {
        width: 200px !important;
      }

      .el-input {
        width: 200px !important;
        float: right;
      }
    }

    .esp_psn_body {
      flex: 1;
      padding: 5px 0px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .esp_psn_footer {
      text-align: right;
    }
  }

  &.esp_dialog .el-dialog__body .el-scrollbar__view {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/psndoc/EspPsndocM.vue